import React from 'react';
import './CustomerLink.css';

/**
 * 고객 연결 해제 버튼.
 *
 * 정책(2026-10-19 확정): 목록에서 지목한 고객은 **수정해도 연결이 풀리지 않는다**.
 * 대신 연결된 동안 이름 칸을 잠그고, 끊으려면 이 ✕ 를 누른다.
 * 자동 해제를 쓰면 "이름만 있는 고객에게 번호를 받아 적는" 가장 흔한 수정에서
 * 연결이 조용히 풀려 동명이인이 또 생긴다 (그게 원래 고치려던 문제다).
 *
 * 예외로 연락처 칸은 **지목한 고객에게 번호가 없을 때만** 열어둔다. 거기 입력한 번호는
 * 서버가 고객 마스터에 채운다(routes/jobs.js backfillCustomerPhone) → 다음 방문부터
 * 번호로 자동 매칭되어 중복의 뿌리가 끊긴다. 이미 번호가 있으면 잠근다 —
 * 접수 화면에서 고객 마스터를 덮어쓰지 않는다.
 */
const UnlinkButton = ({ onUnlink, title = '고객 연결 해제' }) => (
    <button type="button" className="cl-unlink" onClick={onUnlink} title={title}>✕</button>
);

export default UnlinkButton;
